import React from 'react';

import ForgotPasswordLinkSent from '@/modules/user/components/VerificationByEmail/ForgotPasswordLinkSent';

const ForgotPasswordLinkSentPage = () => (
  <ForgotPasswordLinkSent />
);

export default ForgotPasswordLinkSentPage;
